import * as types from 'src/shared/app/signup/action/signupActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  email: null,
  code: null,
  error: null,
  isPasswordSet: false,
};

const setEmail = (
  state: Record<string, any>,
  { email, isPasswordSet }: Record<string, any>,
): Record<string, any> => ({ ...state, email, isPasswordSet });

const resetEmail = (state: Record<string, any>): Record<string, any> => ({
  ...state,
  email: null,
  isPasswordSet: false,
});

const setCode = (
  state: Record<string, any>,
  { code }: Record<string, any>,
): Record<string, any> => ({ ...state, code });

const resetCode = (state: Record<string, any>): Record<string, any> => ({
  ...state,
  code: null,
});

export default createReducer(initialState, {
  [types.VALIDATE_SIGNUP_EMAIL_REQUEST]: resetEmail,
  [types.VALIDATE_SIGNUP_EMAIL_FAILURE]: resetEmail,
  [types.VALIDATE_SIGNUP_EMAIL_SUCCESS]: setEmail,
  [types.VALIDATE_SIGNUP_ACTIVATION_CODE_REQUEST]: resetCode,
  [types.VALIDATE_SIGNUP_ACTIVATION_CODE_FAILURE]: resetCode,
  [types.VALIDATE_SIGNUP_ACTIVATION_CODE_SUCCESS]: setCode,
});
